import { Button, CircularProgress } from "@mui/material";
import { useStyles } from "./SummaryReportDashboardFilters.styles";
import { useTranslation } from "react-i18next";
import useSummaryReportsDashboardFilters, {
    initialSummaryReportDashboardFilters,
} from "./useSummaryReportDashboardFilters";
import FilterSelect from "components/MainSelect/MainSelect.view";
import { useContext } from "react";
import { MillDashboardContext } from "contexts/MillDashboardsContext/MillDashboardsContext";
import { FiltersDefaultButton } from "pages/Corporate/components/FiltersDefaultButton/FiltersDefaultButton.view";

const SummaryReportDashboardFilters = () => {
    const classes = useStyles();
    const {
        machineCentersOptions,
        functionalLocationsOptions,
        shiftsOptions,
        failureTypesOptions,
        isLoading,
        filters,
        applyFilters,
        resetFilters,
        handleFiltersChange,
        setDefaultFilters,
        removeDefaultFilters,
        isFiltersDefault,
        userFiltersDefault,
        loadingDefaultOperations,
    } = useSummaryReportsDashboardFilters();
    const { reportRangeEndDate: endDate, reportRangeStartDate: startDate } = useContext(MillDashboardContext);
    const { t } = useTranslation();

    if (isLoading) {
        return (
            <div className={`${classes.mainWrapper} ${classes.mainWrapperLoading}`}>
                <CircularProgress color="info" />
            </div>
        );
    }

    return (
        <div className={classes.mainWrapper}>
            <div className={classes.filtersWrapper}>
                <FilterSelect
                    order={"asc"}
                    multiple
                    label={t("locations.summary_report.filters.machine_center")}
                    options={machineCentersOptions}
                    value={filters.machineCenter}
                    onChange={(event) =>
                        handleFiltersChange({
                            machineCenter: event.target.value,
                            functionalLocation: initialSummaryReportDashboardFilters.functionalLocation,
                            failureTypes: initialSummaryReportDashboardFilters.failureTypes,
                        })
                    }
                />
                <FilterSelect
                    order={"asc"}
                    label={t("locations.summary_report.filters.functional_location")}
                    options={functionalLocationsOptions}
                    value={filters.functionalLocation}
                    onChange={(event) => handleFiltersChange({ functionalLocation: event.target.value })}
                />
                <FilterSelect
                    order={"asc"}
                    label={t("locations.summary_report.filters.shift")}
                    options={shiftsOptions}
                    value={filters.shift}
                    onChange={(event) => handleFiltersChange({ shift: event.target.value })}
                />
                <FilterSelect
                    order={"asc"}
                    multiple
                    label={t("locations.summary_report.filters.failure_type")}
                    options={failureTypesOptions}
                    value={filters.failureTypes}
                    onChange={(event) =>
                        handleFiltersChange({
                            failureTypes: event.target.value,
                        })
                    }
                />
            </div>
            <div className={classes.filtersActionsWrapper}>
                <FiltersDefaultButton
                    isSelected={isFiltersDefault}
                    hasDefault={!!userFiltersDefault}
                    handleOperation={isFiltersDefault ? removeDefaultFilters : setDefaultFilters}
                    disabled={loadingDefaultOperations}
                />
                <div className={classes.link} onClick={() => resetFilters()}>
                    {t("locations.summary_report.filters.clear_filters")}
                </div>
                <Button
                    variant="contained"
                    color="info"
                    disabled={!startDate || !endDate}
                    onClick={() => applyFilters()}
                >
                    {t("locations.summary_report.filters.apply_filters")}
                </Button>
            </div>
        </div>
    );
};

export default SummaryReportDashboardFilters;
